export default function imageBoxWidget(editor) {
  editor.DomComponents.addType('eb-image-box', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-image-box'
    },
    model: {
      defaults: {
        name: 'Image Box',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-image-box' },
        style: {
          'text-align': 'center',
          'padding': '20px',
        },
        components: `
          <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiB2aWV3Qm94PSIwIDAgMjAwIDIwMCI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiNlMGUwZTAiIHJ4PSIxMDAiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5JbWFnZTwvdGV4dD48L3N2Zz4=" alt="Image Box" style="width:150px;height:150px;border-radius:50%;object-fit:cover;margin-bottom:15px;" />
          <h4 style="font-size:20px;font-weight:600;color:#333;margin:0 0 8px;">John Doe</h4>
          <p style="font-size:14px;color:#666;margin:0;">A short description or title goes here.</p>
        `,
        traits: [
          { type: 'text', name: 'data-img-src', label: 'Image URL' },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-image-box', {
    label: 'Image Box',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,14L8.5,9.5L11,12.5L14.5,8L19,14H5Z"/></svg>',
    content: { type: 'eb-image-box' },
  })
}
